import React, { createContext, useState, useContext } from 'react';

export const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
  const [isModalVisible, setModalVisible] = useState(false);
  const [modalData, setModalData] = useState({});

  const showModal = (data) => {
    setModalData(data);
    setModalVisible(true);
  };

  const closeModal = () => {
    setModalVisible(false);
    setModalData({});
  };

  return (
    <ModalContext.Provider value={{ isModalVisible, modalData, showModal, closeModal }}>
      {children}
    </ModalContext.Provider>
  );
};

export const useModal = () => {
  return useContext(ModalContext);
};
